import React from 'react';
import Button from '../Button';
import Position from '../Position';
function MenuButton({ buttonText, color, display, onClick }) {
    return (React.createElement(Position, { display: display, left: 13, position: "fixed", top: 13, zIndex: "belowSidebar" },
        React.createElement(Button, { bg: "white", color: color, kind: "ghost", onClick: onClick }, buttonText)));
}
export default MenuButton;
